import React from "react";
import { Dot, LoaderContainer } from './styles';

export default function LoaderPattern({ color, size = "g" }){
    return (
      <LoaderContainer color={color}>
        <Dot size={size} delay="0s">.</Dot>
        <Dot size={size} delay="0.2s">.</Dot>
        <Dot size={size} delay="0.4s">.</Dot>
      </LoaderContainer>
    );
  };
  